import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleExchange } = useAuth();
  const hasRun = React.useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const data = await googleExchange(sid);
        // Returning user with a brand + logs → straight to dashboard.
        // Otherwise route into onboarding (new users or partially-onboarded).
        if (data?.user?.has_brand && data?.user?.log_count > 0) {
          navigate("/dashboard", { replace: true });
        } else if (data?.user?.has_brand) {
          navigate("/onboarding/first-log", { replace: true });
        } else {
          navigate("/onboarding/brand", { replace: true });
        }
      } catch (err) {
        const detail =
          err?.response?.data?.detail ||
          (err?.response?.status ? `Google sign-in failed (HTTP ${err.response.status})` : null) ||
          err?.message ||
          "Google sign-in failed";
        navigate("/login", { replace: true, state: { error: String(detail) } });
      }
    })();
  }, [location, navigate, googleExchange]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50">
      <div className="text-slate-500 text-sm">Signing you in…</div>
    </div>
  );
}
